import { useQuery } from "@tanstack/react-query";
import LeadApi from "../api/LeadApi";

export const useLeadData = (leadId, enabled = false) => {
  const {
    data: leadData,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: ["profilingForm", leadId],
    queryFn: () =>
      LeadApi.fetchLead(leadId, {
        populate: "ofCompany",
        selectPopulate: "name",
      }),
    enabled,
    // staleTime: 24 * 60 * 60 * 1000, // Data remains fresh indefinitely
    staleTime: 30 * 1000, // Data remains fresh indefinitely
    // cacheTime: Infinity,
    cacheTime: 30 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return { leadData, isLoading, leadId, isError, error, refetch };
};
